import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Form } from "antd";
import FormItem from "components/fields/FormItem";
import EmployeeInfoForm from "./EmployeeInfoForm";
import EmegencyContactForm from "./EmegencyContactForm";
import SectionHeader from "components/section/SectionHeader";
import PopupButton from "components/button/PopupButton";
import {
	getEmployeeDetails,
} from "../../../../redux/employee/employeeState";
import { formatAddress, isSeparatedEmployee, contactDetailName } from "utils/index";
import InfoCard from "components/card/InfoCard";
import { 
	LuBriefcase,
	LuBuilding, 
	LuCalendar, 
	LuLayers, 
	LuMail, 
	LuMapPin, 
	LuPhone, 
	LuUsers,
} from "react-icons/lu";




const EmployeeDetails = ({
	getRecord,
	recordData,
	recordId,
}) => {
	const [employee, setEmployee] = useState(null);

	useEffect(() => {
		getRecord(recordId);
	}, [recordId, getRecord]);

	useEffect(() => {
		if (recordData) {
			setEmployee(recordData);
		}
	}, [recordData]);

  	return (
		<div className="grid grid-cols-1 xl:grid-cols-7 gap-4">
			<div className="xl:col-span-4 order-2 xl:order-1">
				<div className="content-wrapper p-5 mb-4 rounded-xl border shadow-md">
					<SectionHeader title="Personal Info">
						<PopupButton id="edit_employee" title="Edit Employee" label="Edit">
							<EmployeeInfoForm recordId={recordId} mode="edit" />
						</PopupButton>
					</SectionHeader>
					<Form layout="vertical">
						<div className="w-full"> 
							<FormItem label="Address" value={formatAddress(recordData?.user_detail?.address)} />
						</div>
						<div className="w-full"> 
							<FormItem label="Birthdate" value={recordData?.emp_birthdate} />
						</div>
						<div className="grid grid-cols-2 w-full"> 
							<FormItem label="SSS #" value={recordData?.emp_sss_number} />
							<FormItem label="Pagibig #" value={recordData?.emp_pagibig_number} />
							<FormItem label="Pagibig MP2 #" value={recordData?.emp_pagibig_number_2} />
							<FormItem label="PhilHealth #" value={recordData?.emp_philhealth_number} />
							<FormItem label="TIN #" value={recordData?.emp_tin} />
							<FormItem label="Bank Account Number" value={recordData?.emp_bank_account} />
						</div>
					</Form>
				</div>

				<div className="content-wrapper p-5 rounded-xl border shadow-md">
					<SectionHeader title="Emergency Contact Info">
						<PopupButton id="edit_emergency_contact" title="Edit Emergency Contact" label="Edit">
							<EmegencyContactForm recordId={recordId} mode="edit" />
						</PopupButton>
					</SectionHeader>

					<Form layout="vertical">
						<div className="grid grid-cols-2 gap-x-2 w-full">
							<FormItem 
								label="Name" 
								value={contactDetailName(recordData?.user_detail?.emergency_contact_person)} 
							/>
							<FormItem 
								label="Mobile Number" 
								value={recordData?.user_detail?.emergency_contact_person?.cde_mobile_number} 
							/>
							<FormItem 
								label="Email" 
								value={recordData?.user_detail?.emergency_contact_person?.cde_email} 
							/>
							<FormItem 
								label="Relation" 
								value={recordData?.user_detail?.emergency_contact_person?.cde_relation} 
							/>
						</div>
					</Form>
				</div>
			</div>
			<div className="xl:col-span-3 order-1 xl:order-2">
				<div className="content-wrapper p-5 rounded-xl border shadow-md h-full">
					<SectionHeader title="Employee Details">
						<PopupButton id="edit_employee" title="Edit Employee" label="Edit">
							<EmployeeInfoForm recordId={recordId} mode="edit" />
						</PopupButton>
					</SectionHeader>

					<Form layout="vertical">
						<div className="grid grid-cols-1 sm:grid-cols-2 w-full gap-3">
							<InfoCard 
								label="Hire Date"
								icon={<LuCalendar />}
								value={recordData?.emp_hire_date}
								span="col-span-2 sm:col-span-1"
							/>
							{isSeparatedEmployee(recordData) && 
								<InfoCard 
									label="Separation Date"
									icon={<LuCalendar />}
									value={recordData?.emp_separation_date}
									span="col-span-2 sm:col-span-1"
								/>
							}
							<InfoCard 
								label="Client Provided Email"
								icon={<LuMail />}
								value={recordData?.emp_company_email}
								span="col-span-2"
							/>
							<InfoCard 
								label="Email"
								icon={<LuMail />}
								value={recordData?.emp_email}
								span="col-span-2"
							/>
							<InfoCard 
								label="Phone"
								icon={<LuPhone />}
								value={recordData?.user_detail?.contact_details?.cde_mobile_number}
								span="col-span-2 sm:col-span-1"
							/>
							<InfoCard 
								label="Country"
								icon={<LuMapPin />}
								value={recordData?.user_detail?.country_name}
								span="col-span-2 sm:col-span-1"
							/>
							<InfoCard 
								label="Job Level"
								icon={<LuLayers />}
								value={recordData?.job_level_name}
								span="col-span-2 sm:col-span-1"
							/>
							<InfoCard 
								label="Employee Type"
								icon={<LuBriefcase />}
								value={recordData?.employment_type_name}
								span="col-span-2 sm:col-span-1"
							/>
							<InfoCard 
								label="Department"
								icon={<LuBuilding />}
								value={recordData?.department_name}
								span="col-span-2 sm:col-span-1"
							/>
							<InfoCard 
								label="Team"
								icon={<LuUsers />}
								value={recordData?.team_name}
								span="col-span-2 sm:col-span-1"
							/>
							{isSeparatedEmployee(recordData) && 
								<InfoCard 
									label="Separation Reason"
									icon={<LuCalendar />}
									value={recordData?.emp_sep_reason_name}
									span="col-span-2"
								/>
							}
						</div>
					</Form>
				</div>
			</div>
		</div>
  	);
};

const mapStateToProps = (state) => ({
  recordData: state.employee.employeeDetails?.data,
  requesting: state.employee.employeeDetails?.requesting,
  success: state.employee.employeeDetails?.success,
});

const mapDispatchToProps = (dispatch) => ({
  getRecord: (id) => dispatch(getEmployeeDetails(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeDetails);
